<template>
  <q-page class="container" padding>
    <PageHeader
      title="Relatório de Ferramentas Associadas por Usuário"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="row col-12 q-col-gutter-sm q-mt-sm">
      <div class="col-md-3 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
        Unidade
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-lg"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="listagem" icon="list" label="Listagem de Usuários" />
      <q-tab name="upload" icon="cloud_upload" label="Upload de Planilha" />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated>
      <!-- Tab Listagem -->
      <q-tab-panel name="listagem" class="q-pa-md">
        <div class="row col-12 q-col-gutter-sm q-mb-md">
          <div
            class="col-md-4 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
          >
            Usuario
            <q-input dense outlined v-model="usuario" />
          </div>

          <div
            class="col-md-4 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
          >
            Ferramenta
            <q-input dense outlined v-model="ferramenta" />
          </div>

          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <p></p>
            <q-btn
              class="q-mt-sm"
              color="primary"
              label="Filtrar"
              no-caps
              icon="filter_alt"
              :disable="disable"
              @click="listarAssosiacoes()"
            />
          </div>
        </div>

        <div class="q-mt-md text-brand-5 text-weight-bold text-body1">
          Ferramentas
        </div>

        <div class="q-my-lg">
          <q-table
            table-header-class="bg-accent text-width-bold"
            id="customers"
            class="table_header tabela-tamanho-fixo"
            dense
            flat
            :rows="listaFornecedores"
            :columns="columns"
            :rows-per-page-options="[0]"
            hide-pagination
            hide-bottom
            v-model:pagination="paginacao"
            :loading="loading"
            :filter="filter"
            @request="handleRequest"
          >
            <template v-slot:top-right>
              <div class="row">
                <q-btn
                  color="secondary"
                  label="Exportar"
                  class="q-mr-md"
                  no-caps
                  icon="file_upload"
                  @click="exportar"
                />

                <q-input
                  outlined
                  rounded
                  dense
                  debounce="300"
                  v-model="filter"
                  placeholder="Pesquisar"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
            </template>

            <template v-slot:body-cell-unidade="props">
              <q-td :props="props">
                {{ props.row.unidade }}
              </q-td>
            </template>
            <template v-slot:body-cell-ferramenta_nome="props">
              <q-td :props="props">
                {{ props.row.ferramenta_nome }}
              </q-td>
            </template>
            <template v-slot:body-cell-ferramenta_descricao="props">
              <q-td :props="props">
                {{ props.row.ferramenta_descricao }}
              </q-td>
            </template>
            <template v-slot:body-cell-nome_usuario="props">
              <q-td :props="props">
                {{ props.row.nome_usuario }}
              </q-td>
            </template>
          </q-table>

          <div class="row justify-start q-mt-md">
            <q-pagination
              :disable="disable"
              v-model="pagination.page"
              color="brand-5"
              active-color="secondary"
              active-text-color="white"
              :max="pagesNumber"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              size="sm"
            />
          </div>
        </div>
      </q-tab-panel>

      <!-- Tab Upload -->
      <q-tab-panel name="upload" class="q-pa-md">
        <upload-component-ferramenta-usuario
          :titulo="'Enviar planilha de ferramentas-usuários'"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import UploadComponentFerramentaUsuario from "../components/UploadComponentFerramentaUsuario.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    ListaUnidadesSelect,
    UploadComponentFerramentaUsuario,
    PageHeader,
  },
  name: "CadastrarFornecedor",
  setup() {
    const loading = ref(false);
    const paginacao = ref({
      page: 1,
      rowsPerPage: 100,
    });
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const usuario = ref("");
    const ferramenta = ref("");
    const $q = useQuasar();
    const busca = ref("");
    let unidade = ref("");
    const listaFornecedores = ref([]);
    const store = useStore();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    let disable = ref(false);
    const columns = [
      {
        name: "nome_vendor",
        label: "Unidade",
        field: "nome_vendor",
        align: "left",
      },
      {
        name: "ferramenta_nome",
        label: "Nome",
        field: "ferramenta_nome",
        align: "left",
      },
      {
        name: "ferramenta_descricao",
        label: "Descrição",
        field: "ferramenta_descricao",
        align: "left",
      },
      {
        name: "numero_patrimonio",
        label: "Nº do Patrimônio",
        field: "numero_patrimonio",
        align: "left",
      },
      {
        name: "nome_usuario",
        label: "Funcionário",
        field: "nome_usuario",
        align: "left",
      },
    ];

    const listarAssosiacoes = async (page = 0, rowsPerPage = 15) => {
      try {
        loading.value = true;
        let resposta = await store.dispatch("fer/listarVinculadosUsuario", {
          vendor_id: store.state.org.unidadeData.id,
          usuario: usuario.value,
          ferramenta: ferramenta.value,
          per_page: rowsPerPage,
          current_page: page,
        });

        listaFornecedores.value = resposta.data.result.data;
        pagination.value.rowsNumber = resposta.data.result.total;
        pagination.value.rowsPerPage = resposta.data.result.per_page;
        paginacao.value = resposta.paginacao;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      setTimeout(() => {
        listarAssosiacoes();
      }, 500);
    });

    const exportar = async () => {
      try {
        await store.dispatch("fer/exportarAssociacoes", {
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message:
            "Relatório Ferramentas vinculadas por usuário. foi exportado, você receberá o link para download em breve em seu email",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      listarAssosiacoes(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarAssosiacoes();
      }
    );

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    onMounted(getUnidadee);

    return {
      listaFornecedores,
      listarAssosiacoes,
      columns,
      emitir,
      paginacao,
      filter: ref(""),
      loading,
      busca,
      disable,
      usuario,
      ferramenta,
      unidade,
      exportar,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      tab: ref("listagem"),
    };
  },
};
</script>

<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
</style>
